import React, { Component } from "react";
import PropTypes from "prop-types";
import LineSeries from "./LineSeries";
import StraightLine from "./StraightLine";

class DisparitySeries extends Component {
  render() {
    const { yAccessor, stroke, strokeZeroLine, className, ...rest } =
      this.props;

    return (
      <g className={className}>
        <LineSeries {...rest} yAccessor={yAccessor} stroke={stroke} />
        <StraightLine yValue={0} stroke={strokeZeroLine} />
      </g>
    );
  }
}

DisparitySeries.propTypes = {
  yAccessor: PropTypes.func.isRequired,
  stroke: PropTypes.object.isRequired,
  strokeZeroLine: PropTypes.object,
  className: PropTypes.string,
  clip: PropTypes.bool,
  onContextMenu: PropTypes.func,
  onDoubleClick: PropTypes.func,
};

DisparitySeries.defaultProps = {
  strokeZeroLine: { color: "#8795A1", dash: "Solid", width: 1, opacity: 1 },
  className: "react-stockcharts-disparity",
  clip: true,
};

export default DisparitySeries;
